import { render, staticRenderFns } from "./lottery-list-reward.vue?vue&type=template&id=5063d80e&scoped=true&"
import script from "./lottery-list-reward.vue?vue&type=script&lang=js&"
export * from "./lottery-list-reward.vue?vue&type=script&lang=js&"
import style0 from "./lottery-list-reward.vue?vue&type=style&index=0&id=5063d80e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063d80e",
  null
  
)

export default component.exports